import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { createOrUpdateMatchPreferences } from "../api/api";
import "./LoveLanguage.css";
import Swal from "sweetalert2";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";
import bgImage from "../../assets/images/brown-background.jpg";

const fields = {
  preferred_relationship_status: "Relationship Status",
  preferred_ethnicity: "Preferred Ethnicity",
  preferred_religion: "Preferred Religion",
  preferred_height: "Preferred Height",
  preferred_body_type: "Preferred Body Type",
  preferred_smoking: "Do You Prefer Smoking Habits",
  preferred_drinking: "Do You Prefer Drinking Habits",
  preferred_age_range: "Preferred Age Range",
  preferred_education_level: "Preferred Education Level",
  // preferred_income: "Preferred Income",
  preferred_qualities_in_partner: "Preferred Qualities In Your Partner",
  description_of_ideal_partner: "Description Of Ideal Partner",
};

const dropdownOptions = {
  preferred_relationship_status: [
    "Single",
    "In a relationship",
    "Other",
    "Prefer not to say",
  ],
  preferred_ethnicity: [
    "Asian",
    "Black",
    "Caucasian",
    "Hispanic",
    "Other",
    "Prefer not to say",
  ],
  preferred_religion: ["Christianity", "Islam", "Other", "Prefer not to say"],
  preferred_height: [
    "< 150 cm",
    "150 - 155 cm",
    "156 - 160 cm",
    "161 - 165 cm",
    "166 - 170 cm",
    "171 - 175 cm",
    "176 - 180 cm",
    "181 - 185 cm",
    "186 - 190 cm",
    "> 190 cm",
    "Any",
  ],
  preferred_body_type: [
    "Athletic",
    "Average",
    "Curvy",
    "Slim",
    "Other",
    "Prefer not to say",
  ],
  preferred_smoking: ["Yes", "No", "Neutral"],
  preferred_drinking: ["Yes", "No", "Neutral"],
  preferred_age_range: ["18-25", "26-35", "36-45", "46+"],
  preferred_education_level: ["High School", "Bachelor's", "Master's", "PhD"],
};

// const textInputFields = [
//   "preferred_education_level",
//   "preferred_income",
//   "preferred_qualities_in_partner",
//   "description_of_ideal_partner",
// ];

const validationSchema = Yup.object(
  Object.fromEntries(
    Object.keys(fields).map((key) => [
      key,
      Yup.string().required(`${fields[key]} is required.`),
    ])
  )
);

const LoveLanguage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      className="love-language-container sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="love-partner">
          <h2 className="love-language-header">Partner Preferences</h2>
          <Formik
            initialValues={Object.fromEntries(
              Object.keys(fields).map((k) => [k, ""])
            )}
            validationSchema={validationSchema}
            onSubmit={async (values) => {
              setLoading(true);
              try {
                const userData = JSON.parse(
                  localStorage.getItem("currentUser")
                );
                const _id = userData?.id || userData?._id;

                const payload = {
                  user_id: _id,
                  profile_completion_status: "UpdateMatchPreferences",
                  ...values,
                };
                console.log("lovelanguage_payload", payload);
                const response = await createOrUpdateMatchPreferences(payload);
                console.log(
                  "createOrUPdateMatchPreferences_response",
                  response
                );

                if (response?.success) {
                  navigate("/UpdateMatchPreferences");
                } else {
                  //   alert(response.message);
                  Swal.fire({
                    title: "Error",
                    text: response.message,
                    icon: "error",
                    confirmButtonText: "OK",
                  });
                }
              } catch (error) {
                console.error("API Error:", error);
                // alert("Something went wrong. Please try again.");
                Swal.fire({
                  title: "Error",
                  text: "Something went wrong. Please try again.",
                  icon: "error",
                  confirmButtonText: "OK",
                });
              } finally {
                setLoading(false);
              }
            }}
          >
            {({ setFieldValue, values }) => (
              <Form className="form-containerall">
                {Object.entries(fields).map(([key, label]) => (
                  <div className="form-group" key={key}>
                    <label>{label}</label>

                    {!dropdownOptions[key] ? (
                      <Field
                        as="textarea"
                        name={key}
                        className="text-input"
                        maxLength={key === "preferred_income" ? 20 : undefined}
                      />
                    ) : (
                      // <Select
                      //   name={key}
                      //   placeholder=""
                      //   options={dropdownOptions[key].map((item) => ({
                      //     label: item,
                      //     value: item,
                      //   }))}
                      //   onChange={(option) => setFieldValue(key, option.value)}
                      //   value={
                      //     values[key]
                      //       ? { label: values[key], value: values[key] }
                      //       : null
                      //   }
                      //   className="dropdown"
                      // />
                      <Select
                        name={key}
                        placeholder=""
                        options={dropdownOptions[key].map((item) => ({
                          label: item,
                          value: item,
                        }))}
                        onChange={(option) => setFieldValue(key, option.value)}
                        value={
                          values[key]
                            ? { label: values[key], value: values[key] }
                            : null
                        }
                        className="dropdown"
                        styles={{
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected
                              ? "#078687"
                              : state.isFocused
                                ? "#deebff"
                                : "#fff",
                            color: state.isSelected ? "#fff" : "#000",
                            cursor: "pointer",
                            // width: "50vw",
                            // width: window.innerWidth <= 991 ? "75vw" : "50vw",
                            // width:
                            //   window.innerWidth <= 500
                            //     ? "75vw"
                            //     : window.innerWidth <= 991
                            //       ? "80vw"
                            //       : window.innerWidth <= 1024
                            //         ? "75vw"
                            //         : window.innerWidth <= 1400
                            //           ? "60vw"
                            //           : "50vw",
                            width: "100%",
                            borderRadius: "15px",
                            marginTop: "5px",
                            marginBottom: "5px",
                            padding: "10px 16px",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            width: "100%",
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            width: "100%",
                          }),
                          control: (provided) => ({
                            ...provided,
                            borderRadius: "30px",
                            minHeight: "45px",
                            boxShadow: "0px 4px 8px rgba(242, 92, 84, 0.25)",
                            width: "100%",
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: "#000",
                          }),
                        }}
                      />
                    )}
                    <ErrorMessage
                      name={key}
                      component="div"
                      className="error-message"
                    />
                  </div>
                ))}

                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default LoveLanguage;
